function getCsrfToken (): string {
  const token = document.getElementsByName('csrf-token')[0].getAttribute("content");
  if (!token) throw 'No CSRF token found!';
  return token;
}

export default getCsrfToken;
